<template>
    <main class="landing-container">
        <section class="slogan">
            <div class="main-title-wrapper">
                <div class="main-title">{{ $t("lp-collector48") }} <span>{{ $t("lp-collector49") }}</span></div>
                <div class="main-subtitle">{{ $t("lp-collector50") }}</div>
                <nuxt-link :to="localePath('/register')" class="main-btn">{{ $t("lp-reg24") }}</nuxt-link>
            </div>
        </section>
        <section class="investor2">
            <div class="container1366 padding120 padding40">
                <div class="investor2-item item1">
                    <div class="investor2-item-title">{{ $t("lp-collector3") }}<br/>{{ $t("lp-collector4") }}</div>
                    <div class="investor2-item-text">{{ $t("lp-collector5") }}</div>
                </div>
                <div class="investor2-item item2">
                    <div class="investor2-item-title">{{ $t("lp-collector6") }}<br/>{{ $t("lp-collector7") }}</div>
                    <div class="investor2-item-text">{{ $t("lp-collector8") }}</div>
                </div>
                <div class="investor2-item item3">
                    <div class="investor2-item-title">{{ $t("lp-collector9") }}<br/>{{ $t("lp-collector10") }}</div>
                    <div class="investor2-item-text">{{ $t("lp-collector11") }}</div>
                </div>
                <div class="investor2-item item4">
                    <div class="investor2-item-title">{{ $t("lp-collector12") }}<br/>{{ $t("lp-collector13") }}</div>
                    <div class="investor2-item-text">{{ $t("lp-collector14") }}</div>
                </div>
            </div>
        </section>
        <section class="investor3">
            <div class="container1366 padding120 padding80">
                <div class="investor3-item investor3-item1 investor3-item-bottom">
                    <div class="investor3-img img1"></div>
                    <div class="investor3-content">
                        <div class="investor3-content-title">{{ $t("lp-collector15") }} <span>{{ $t("lp-collector16") }}</span></div>
                        <div class="investor3-content-text">{{ $t("lp-collector17") }}</div>
                        <nuxt-link aria-label="wine live market page" :to="localePath('/trading-desk')" class="main-btn">{{ $t("howitworks9") }}</nuxt-link>
                    </div>
                </div>
                <div class="investor3-item investor3-item2 investor3-item-bottom">
                    <div class="investor3-img img2"></div>
                    <div class="investor3-content">
                        <div class="investor3-content-title">{{ $t("lp-collector18") }} <span>{{ $t("lp-collector19") }}</span></div>
                        <div class="investor3-content-text">{{ $t("lp-collector20") }}</div>
                        <nuxt-link aria-label="wine collections page" :to="localePath('/collections')" class="main-btn">{{ $t("howitworks7") }}</nuxt-link>
                    </div>
                </div>
                <div class="investor3-item investor3-item3">
                    <div class="investor3-img img3"></div>
                    <div class="investor3-content">
                        <div class="investor3-content-title">{{ $t("lp-collector21") }}</div>
                        <div class="investor3-content-text">{{ $t("lp-collector22") }}</div>
                        <nuxt-link aria-label="en primeur page" :to="localePath('/en-primeur')" class="main-btn">{{ $t("discover-enprimeur") }}</nuxt-link>
                    </div>
                </div>
            </div>
        </section>
        <section class="investor4">
            <div class="container1366 padding120 padding80">
                <div class="investor4-item item1">
                    <div class="investor2-item-title">{{ $t("lp-collector23") }}</div>
                    <div class="investor2-item-text">{{ $t("lp-collector24") }}</div>
                    <a @click="goSection('portfolio-performance')" href="javascript:;" class="main-btn">{{ $t("lp-collector25") }}</a>
                </div>
                <div class="investor4-item item2">
                    <div class="investor2-item-title">{{ $t("lp-collector26") }}</div>
                    <div class="investor2-item-text">{{ $t("lp-collector27") }}</div>
                    <nuxt-link :to="localePath('/register')" class="main-btn">{{ $t("lp-reg24") }}</nuxt-link>
                </div>
                <div class="investor4-item item3">
                    <div class="investor2-item-title">{{ $t("lp-collector28") }}</div>
                    <div class="investor2-item-text">{{ $t("lp-collector29") }}</div>
                    <nuxt-link :to="localePath('/support?selectedTopic=storage')" class="main-btn">{{ $t("new-home4") }}</nuxt-link>
                </div>
            </div>
        </section>
        <section class="investor5">
            <div class="container1366 padding120 padding80">
                <div class="investor5-left">
                    <div class="investor5-left-title">{{ $t("lp-collector30") }} <span>{{ $t("lp-collector31") }}</span></div>
                    <div class="investor5-left-text">{{ $t("lp-collector32") }}</div>
                </div>
                <div class="investor5-right">
                    <div class="investor5-right-row1">
                        <div class="investor5-right-item item1">
                            <div class="investor5-right-item-title">100+</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector33") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector34") }}</div>
                        </div>
                        <div class="investor5-right-item item2">
                            <div class="investor5-right-item-title">20+%</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector35") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector36") }}</div>
                        </div>
                    </div>
                    <div class="investor5-right-row2">
                        <div class="investor5-right-item item3">
                            <div class="investor5-right-item-title">30,000+</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector37") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector38") }}</div>
                        </div>
                        <div class="investor5-right-item item4">
                            <div class="investor5-right-item-title">€ 2,800</div>
                            <div class="investor5-right-item-text">{{ $t("lp-collector39") }}</div>
                            <div class="investor5-right-item-text1">{{ $t("lp-collector40") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="investor6">
            <div class="container1366 padding120 padding80">
                <div class="investor6-left">
                    <div>
                        <div class="investor6-left-title">{{ $t("lp-collector41") }} <span>{{ $t("lp-collector42") }}</span> {{ $t("lp-collector43") }}!</div>
                        <i18n class="investor6-left-text" path="lp-collector44" tag="div">
                            <nuxt-link :to="localePath('/register')" place="action">vindome.net</nuxt-link>
                        </i18n>
                    </div>
                    <div class="investor6-left-icons">
                        <a href="https://play.google.com/store/apps/details?id=com.vindome.wine&hl=en_US&gl=US" target="_blank">
                            <div class="investor6-left-icons-android"></div>
                        </a>
                        <a href="https://apps.apple.com/us/app/vindome/id1494570524" target="_blank">
                            <div class="investor6-left-icons-ios"></div>
                        </a>
                    </div>
                </div>
                <div class="investor6-right"></div>
            </div>
        </section>
    </main>
</template>

<script>

    export default {
        name: "LpWineCollector",
        head: {
            title: 'Wine Collector | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-investor'
            }
        },
        methods: {
            goSection(val) {
                setTimeout(() => {
                    this.$nuxt.$emit("goToSection", val);
                }, 500)
                this.$router.push(this.localePath({path: '/wine-academy'}));

            }
        }
    }
</script>

<style scoped>
    .slogan {
        height: 688px;
        position: relative;
        background: url('../assets/landing/investor/hero2.png') no-repeat center;
        background-size: cover;
    }
    .main-title-wrapper {
        width: 1127px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-right: 420px;
        background: url('../assets/landing/investor/2iPhones.png') no-repeat right 57px;
        background-size: 380px 575px;
    }
    .main-title {
        color: #ffffff;
        font-family: Montserrat;
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin-bottom: 16px;
        max-width: 480px;
    }
    html[lang=de] .main-title {
        max-width: 100%;
        font-size: 44px;
    }
    html[lang=it] .main-title {
        max-width: 100%;
    }
    .main-title span {
        color: #E2C477;
    }
    .main-subtitle {
        color: white;
        font-family: Montserrat;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 32px;
    }
    .main-btn {
        border-radius: 8px;
        border: 2px solid white;
        background: rgba(255, 255, 255, 0.16);
        padding: 16px;
        color: white;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-decoration: none;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding120 {
        padding: 0 120px;
    }
    .padding40 {
        padding-top: 40px;
        padding-bottom: 40px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .investor2-item-title {
        color: #002840;
        font-family: Montserrat;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        align-self: stretch;
        margin-bottom: 8px;
    }
    .investor2-item-text {
        color: #002840;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        align-self: stretch;
    }
    .investor2-item {
        padding-top: 72px;
        padding-bottom: 16px;
        width: calc((100% - 132px) / 4);
        display: inline-block;
        vertical-align: top;
    }
    .investor2-item.item1, .investor2-item.item2, .investor2-item.item3 {
        margin-right: 40px;
    }
    .investor2-item.item1 {
        background: url('../assets/landing/investor/icon1.png') no-repeat left 16px;
        background-size: 40px;
    }
    .investor2-item.item2 {
        background: url('../assets/landing/investor/icon2.png') no-repeat left 16px;
        background-size: 40px;
    }
    .investor2-item.item3 {
        background: url('../assets/landing/investor/icon3.png') no-repeat left 16px;
        background-size: 40px;
    }
    .item4 {
        background: url('../assets/landing/investor/icon4.png') no-repeat left 16px;
        background-size: 40px;
    }
    .investor3 {
        background: linear-gradient(180deg, #45677B 0%, #00304D 100%);
        flex-direction: column;
        align-items: center;
        gap: 80px;
        align-self: stretch;
        display: flex;
    }
    .investor3-item {
        display: flex;
        gap: 40px;
        justify-content: space-between;
        height: 346px;
    }
    .investor3-img {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch;
    }
    .investor3-img.img1 {
        background: url('../assets/landing/investor/sec3-1.png') no-repeat center;
        background-size: contain;
    }
    .investor3-img.img2 {
        background: url('../assets/landing/investor/sec3-2.png') no-repeat center;
        background-size: contain;
    }
    .investor3-img.img3 {
        background: url('../assets/landing/investor/sec3-3.png') no-repeat center;
        background-size: contain;
    }
    .investor3-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex: 1 0 0;
        align-self: stretch;
    }
    .investor3-content-title {
        color: white;
        font-family: Montserrat;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        margin-bottom: 16px;
    }
    .investor3-content-title span {
        color: #E2C477;
    }
    .investor3-content-text {
        color: white;
        font-family: Montserrat;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        opacity: 0.8;
        margin-bottom: 32px;
    }
    .investor3-item-bottom {
        margin-bottom: 80px;
    }
    .investor4 {
        background: linear-gradient(180deg, #8E8E8E 0%, #717172 100%);
    }
    .investor4 .container1366 {
        display: flex;
        align-items: center;
        gap: 40px;
        align-self: stretch;
    }
    .investor4-item {
        display: flex;
        padding: 72px 0 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;
        align-self: stretch;
    }
    .investor4-item .investor2-item-title {
        color: #E2C477;
    }
    .investor4-item .investor2-item-text {
        color: #ffffff;
    }
    .investor4-item.item1 {
        background: url('../assets/landing/investor/sec4-1.png') no-repeat left 16px;
        background-size: 40px;
    }
    .investor4-item.item2 {
        background: url('../assets/landing/investor/sec4-2.png') no-repeat left 16px;
        background-size: 40px;
    }
    .investor4-item.item3 {
        background: url('../assets/landing/investor/sec4-3.png') no-repeat left 16px;
        background-size: 40px;
    }
    .investor4-item .investor2-item-text {
        min-height: 88px;
    }
    .investor5 {
        background: white;
    }
    .investor5 .container1366 {
        display: flex;
        align-items: center;
        gap: 40px;
    }
    .investor5-left, .investor5-right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex: 1 0 0;
    }
    .investor5-left {
        align-self: stretch;
        justify-content: flex-start;
    }
    .investor5-left-title {
        color: #C7AC69;
        font-family: Montserrat;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        align-self: stretch;
        margin-bottom: 16px;
    }
    .investor5-left-title span {
        color: #002840;
    }
    .investor5-left-text {
        color: #002840;
        font-family: Montserrat;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        opacity: 0.8;
    }
    .investor5-left {
        background: url('../assets/landing/investor/sec5.png') no-repeat center bottom;
        background-size: 100%;
    }
    .investor5-right-row1, .investor5-right-row2 {
        display: flex;
        align-items: center;
        align-self: stretch;
    }
    .investor5-right-item {
        display: flex;
        padding-bottom: 0;
        flex-direction: column;
        align-items: flex-start;
        flex: 1 0 0;
        align-self: stretch;
    }
    .investor5-right-item.item1 {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        border-right: 1px solid rgba(0, 0, 0, 0.12);
        padding-bottom: 24px;
        background: url('../assets/landing/investor/sec5-1.png') no-repeat left top;
        background-size: 80px;
        padding-top: 96px;
    }
    .investor5-right-item.item2 {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        padding-left: 24px;
        padding-bottom: 24px;
        background: url('../assets/landing/investor/sec5-2.png') no-repeat 24px top;
        background-size: 80px;
        padding-top: 96px;
    }
    .investor5-right-item.item3 {
        border-right: 1px solid rgba(0, 0, 0, 0.12);
        background: url('../assets/landing/investor/sec5-3.png') no-repeat left 24px;
        background-size: 80px;
        padding-top: 120px;
    }
    .investor5-right-item.item4 {
        padding-left: 24px;
        background: url('../assets/landing/investor/sec5-4.png') no-repeat 24px 24px;
        background-size: 80px;
        padding-top: 120px;
    }
    .investor5-right-item-title {
        color: #002840;
        font-family: Montserrat;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        align-self: stretch;
    }
    .investor5-right-item-text {
        color: rgba(0, 0, 0, 0.64);
        font-family: Montserrat;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
        opacity: 0.8;
        align-self: stretch;
    }
    .investor5-right-item-text1 {
        opacity: 0.8;
        color: #C6AC69;
        font-family: Montserrat;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: capitalize;
        align-self: stretch;
    }
    .investor6 {
        background: #EBE9E9;
    }
    .investor6 .container1366 {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 40px;
        align-self: stretch;
    }
    .investor6-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;
        align-self: stretch;
        height: 228px;
        padding: 21px 0;
    }
    .investor6-right {
        height: 228px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch;
        background: url('../assets/landing/investor/sec6.png') no-repeat center;
        background-size: contain;
    }
    .investor6-left-title {
        color: #002840;
        font-family: Montserrat;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        align-self: stretch;
        margin-bottom: 16px;
    }
    .investor6-left-title span {
        color: #C7AC69;
    }
    .investor6-left-text {
        opacity: 0.8;
        color: #002840;
        font-family: Montserrat;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 16px;
    }
    .investor6-left-text a {
        color: #3C789D;
        text-decoration-line: underline;
    }
    .investor6-left-icons {
        display: flex;
        flex-direction: row;
    }
    .investor6-left-icons-android {
        width: 148px;
        height: 45px;
        margin-right: 24px;
        background: url('../assets/landing/investor/sec6-1.png') no-repeat center;
        background-size: contain;
    }
    .investor6-left-icons-ios {
        width: 134px;
        height: 45px;
        background: url('../assets/landing/investor/sec6-2.png') no-repeat center;
        background-size: contain;
    }

    @media (width: 1024px) {
        .slogan {
            height: 567px;
            padding: 0 120px;
        }
        .main-title-wrapper {
            width: 100%;
            padding-right: 340px;
            background: url('../assets/landing/investor/2iPhones.png') no-repeat right 54px;
            background-size: 300px 459px;
        }
        .main-title,
        html[lang=de] .main-title {
            font-size: 40px;
        }
        .main-subtitle {
            font-size: 18px;
        }
        .investor3-item {
            height: 288px;
        }
        .padding120 {
            padding: 80px;
        }
        .investor5-left {
            background-size: 412px 267px;
        }
        .investor6-right, .investor6-left {
            height: 194px;
        }
        .investor6-left {
            gap: 0;
        }
        html[lang=de] .investor6-left-title {
            font-size: 27px;
        }
        html[lang=de] .investor2-item-title {
            font-size: 17px;
        }
    }

    @media (width: 768px) {
        .slogan {
            height: 411px;
            padding: 0 40px;
        }
        .main-title-wrapper {
            width: 100%;
            padding-right: 274px;
            background: url('../assets/landing/investor/2iPhones.png') no-repeat right 16px;
            background-size: 250px 379px;
        }
        .main-title {
            font-size: 32px;
        }
        html[lang=de] .main-title {
            font-size: 25px;
        }
        .main-subtitle {
            font-size: 17px;
            margin-bottom: 16px;
        }
        .padding120 {
            padding: 0 40px;
        }
        .padding40 {
            padding-top: 40px;
            padding-bottom: 40px;
        }
        .padding80 {
            padding-top: 40px;
            padding-bottom: 40px;
        }
        .investor3-item {
            height: 234px;
        }
        .investor3-content-title,
        .investor5-left-title,
        .investor6-left-title {
            font-size: 22px;
        }
        .investor3-content-text,
        .investor6-left-text {
            font-size: 16px;
        }
        .investor2-item-title,
        .investor5-right-item-title {
            font-size: 18px;
        }
        .investor2-item-text {
            font-size: 12px;
        }
        .investor5-left-text,
        .investor5-right-item-text,
        .investor5-right-item-text1 {
            font-size: 14px;
        }
        .investor5-right-item.item1 {
            background-size: 40px;
            padding-top: 40px;
            padding-bottom: 10px;
        }
        .investor5-right-item.item2 {
            padding-top: 40px;
            padding-left: 16px;
            background: url('../assets/landing/investor/sec5-2.png') no-repeat 16px top;
            background-size: 40px;
            padding-bottom: 10px;
        }
        .investor5-right-item.item3 {
            background: url('../assets/landing/investor/sec5-3.png') no-repeat left 16px;
            background-size: 40px;
            padding-top: 56px;
        }
        .investor5-right-item.item4 {
            padding-left: 16px;
            background: url('../assets/landing/investor/sec5-4.png') no-repeat 16px 16px;
            background-size: 40px;
            padding-top: 56px;
        }
        .investor5-left {
            background-size: 270px 175px;
        }
        .investor6-left {
            gap: 0;
        }
        .investor6-right, .investor6-left {
            height: 155px;
        }
        .main-btn {
            font-size: 14px;
        }
        .investor4 .container1366 {
            gap: 24px
        }
        html[lang=de] .investor2-item-title {
            font-size: 13px;
        }
        html[lang=de] .investor3-content-text {
            font-size: 12px;
        }
        .investor6-left {
            padding: 0;
        }
    }

    @media (max-width: 767px) {
        .slogan {
            height: auto;
            padding: 24px 16px 40px;
        }
        .main-title-wrapper {
            width: 100%;
            background: transparent;
            padding: 0;
        }
        .main-title {
            font-size: 32px;
        }
        .main-subtitle {
            font-size: 18px;
        }
        .padding120 {
            padding: 0 16px;
        }
        .padding40 {
            padding-top: 16px;
            padding-bottom: 16px;
        }
        .padding80 {
            padding-top: 16px;
            padding-bottom: 16px;
        }
        .investor2-item.item1, .investor2-item.item2, .investor2-item.item3 {
            margin-right: 0;
            margin-bottom: 16px;
            width: 100%;
        }
        .investor2-item.item4 {
            width: 100%;
        }
        .investor3 {
            gap: 24px;
        }
        .investor3 .padding80 {
            padding-top: 24px;
            padding-bottom: 24px;
        }
        .investor3-item1, .investor3-item2, .investor3-item3 {
            height: auto;
            display: block;
        }
        .investor3-img.img1 {
            height: 214px;
            margin-bottom: 14px;
        }
        .investor3-img.img2 {
            height: 214px;
            margin-bottom: 14px;
        }
        .investor3-img.img3 {
            height: 214px;
            margin-bottom: 14px;
        }
        .investor3-item-bottom[data-v-33992033] {
            margin-bottom: 24px;
        }
        .investor4 .container1366 {
            flex-direction: column;
            gap: 24px;
        }
        .investor4 .padding80 {
            padding-top: 24px;
            padding-bottom: 24px;
        }
        .investor5 .padding80 {
            padding-top: 24px;
            padding-bottom: 24px;
            display: block;
        }
        .investor5-left {
            height: 217px;
            background-size: 258px 167px;
            margin-bottom: 16px;
        }
        .investor5-right {
            align-self: stretch;
        }
        .investor5-left-title {
            font-size: 22px;
            margin-bottom: 8px;
        }
        .investor5-right-item-title {
            font-size: 18px;
        }
        .investor5-left-text,
        .investor5-right-item-text,
        .investor5-right-item-text1 {
            font-size: 14px;
        }
        .investor5-right-item.item1 {
            background-size: 40px;
            padding-top: 40px;
            padding-bottom: 10px;
        }
        .investor5-right-item.item2 {
            padding-top: 40px;
            padding-left: 16px;
            background: url('../assets/landing/investor/sec5-2.png') no-repeat 16px top;
            background-size: 40px;
            padding-bottom: 10px;
        }
        .investor5-right-item.item3 {
            background: url('../assets/landing/investor/sec5-3.png') no-repeat left 16px;
            background-size: 40px;
            padding-top: 56px;
        }
        .investor5-right-item.item4 {
            padding-left: 16px;
            background: url('../assets/landing/investor/sec5-4.png') no-repeat 16px 16px;
            background-size: 40px;
            padding-top: 56px;
        }
        .investor6 .container1366 {
            display: block;
        }
        .investor6 .padding80 {
            padding-top: 174px;
            padding-bottom: 24px;
            background: url('../assets/landing/investor/sec6.png') no-repeat center 24px;
            background-size: 288px 136px;
        }
        .investor6-right {
            display: none;
        }
        .investor6-left {
            gap: 0;
            height: 204px;
        }
        .investor6-left-title {
            font-size: 22px;
        }
        .investor6-left-text {
            font-size: 14px;
        }
        html[lang=de] .main-title {
            font-size: 21px;
        }
    }
</style>
<style>
    .page-landing-investor .v-main {
        padding-top: 80px !important;
    }
</style>
